import { useEffect, useState } from "react";
import styled from "styled-components";
import AdminSidebar from "../../../components/sidebar/AdminSidebar";
import H3 from "../../../components/typography/H3";
import colors from "../../../theme/color/ColorTheme";
import { ReactComponent as InfoSvg } from "../../../assets/images/icons/info.svg";
import fontSize from "../../../theme/fonts/FontTheme";
import PaginationDropDown from "../../../components/input/PaginationDropDown";
import SearchInputBar from "../../../components/input/SearchInputBar";
import InputfieldWithDropDown from "../../../components/input/InputfieldWithDropDown";
import AdminActionsButton from "../../../components/button/AdminActionsButton";
import CategoryTable from "./components/CategoryTable";
const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const Nav = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  z-index: 10;

  @media (max-width: 1024px) {
    position: relative;
    height: auto;
    width: 100%;
  }
`;

const Content = styled.div`
  flex: 1;
  background-color: ${colors.backgroundTintPrimary};
  padding: 20px;
  margin-left: 260px;
  width: calc(100% - 260px);
  @media (max-width: 1200px) {
    margin-left: 80px;
    width: calc(100% - 80px);
    padding: 15px;
  }

  @media (max-width: 1024px) {
    margin-left: 0;
    width: 100%;
    padding: 10px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px;
  border-radius: 12px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  @media (max-width: 768px) {
    padding: 20px 15px;
    border-radius: 8px;
  }
`;
const SortFilterContainer = styled.div`
  padding: 24px;
  margin-top: 20px;
  margin-bottom: 30px;
  background-color: ${colors.backgroundTintSecondary};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const InfoTextSpan = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: ${fontSize.xs};
`;
const FixedInputWrapper = styled.div`
  width: 20%;
  & > div {
    width: 100%;
  }
  input,
  select {
    width: 100%;
    box-sizing: border-box;
  }
`;
function CategoriesPage() {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const categories = [
    {
      id: "P001",
      category: "Apparel",
      quantity: 120,
      sale: 12,
    },
    {
      id: "P001",
      category: "Apparel",
      quantity: 120,
      sale: 12,
    },
    {
      id: "P001",
      category: "Apparel",
      quantity: 120,
      sale: 12,
    },
    {
      id: "P001",
      category: "Apparel",
      quantity: 120,
      sale: 12,
    },
  ];

  return (
    <Wrapper>
      <Nav>
        <AdminSidebar collapsed={window.innerWidth < 1200} />
      </Nav>
      <Content>
        <Container>
          <H3>Products</H3>

          <SortFilterContainer>
            <InfoTextSpan>
              <InfoSvg />
              <p>
                Tip search by Product ID: Each product is provided with a unique
                ID, which you can rely on to find the exact product you need.
              </p>
            </InfoTextSpan>
            <ControlsRow>
              <PaginationDropDown />
              <SearchInputBar />
              <FixedInputWrapper>
                <InputfieldWithDropDown
                  type="dropdown"
                  value={selectedCategory}
                  onChange={(val) => setSelectedCategory(val)}
                  options={[
                    "Clothing",
                    "Shoes",
                    "Accessories",
                    "Electronics",
                    "Home",
                  ]}
                  placeholder="Category"
                />
              </FixedInputWrapper>
              <AdminActionsButton children={"+ Add Category"} />
            </ControlsRow>
          </SortFilterContainer>
          <CategoryTable categories={categories} />
        </Container>
      </Content>
    </Wrapper>
  );
}

export default CategoriesPage;
